<template>
  <CRow>
    <CCol sm="6" lg="3">
      <CWidgetDropdown
        color="warning"
        :header="
          (outlet && outlet.count && outlet.count != 0 ? outlet.count : 0)
            | thousandSeparatorStr
        "
        :text="`Jumlah Outlet Terdaftar`"
      >
        <template #footer>
          <CChartLineSimple
            pointed
            class="mt-3 mx-3"
            style="height: 70px"
            :data-points="outlet.per_month"
            point-hover-background-color="warning"
            label="Outlet"
            labels="months"
          />
        </template>
      </CWidgetDropdown>
    </CCol>
    <CCol sm="6" lg="3">
      <CWidgetDropdown
        color="success"
        :header="
          (user && user.count && user.count != 0 ? user.count : 0)
            | thousandSeparatorStr
        "
        :text="`User Teregistrasi`"
      >
        <template #footer>
          <CChartLineSimple
            pointed
            class="mt-3 mx-3"
            style="height: 70px"
            :data-points="user.per_month"
            point-hover-background-color="success"
            label="Users"
            labels="months"
          />
        </template>
      </CWidgetDropdown>
    </CCol>
    <CCol sm="6" lg="3">
      <CWidgetDropdown
        color="danger"
        :header="
          (catalog && catalog.count && catalog.count != 0 ? catalog.count : 0)
            | thousandSeparatorStr
        "
        :text="`Jumlah Produk Katalog`"
      >
        <template #footer>
          <CChartLineSimple
            pointed
            class="mt-3 mx-3"
            style="height: 70px"
            :data-points="catalog.per_month"
            point-hover-background-color="danger"
            label="Product"
            labels="months"
          />
        </template>
      </CWidgetDropdown>
    </CCol>
    <CCol sm="6" lg="3">
      <CWidgetDropdown
        color="primary"
        :header="
          (transactions && transactions.count && transactions.count != 0
            ? transactions.count
            : 0) | thousandSeparatorStr
        "
        :text="`Total transaksi`"
      >
        <template #footer>
          <CChartLineSimple
            pointed
            class="mt-3 mx-3"
            style="height: 70px"
            :data-points="transactions.per_month"
            point-hover-background-color="primary"
            label="Members"
            labels="months"
          />
        </template>
      </CWidgetDropdown>
    </CCol>

    <CCol md="12">
      <CCard>
        <CCardHeader> Outlet Per Kota</CCardHeader>
        <CCardBody>
          <CRow>
            <CCol sm="12">
              <div
                class="progress-group mb-4"
                v-for="(v, k) in outletPerCity"
                :key="k"
              >
                <div class="progress-group-prepend">
                  <span class="progress-group-text"> {{ v.city }} </span>
                </div>
                <div class="progress-group-bars">
                  <CProgress
                    class="progress-xs"
                    color="info"
                    :value="v.count"
                  />
                </div>
              </div>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CChartLineSimple from "../components/CChartLineSimple";
import { HTTPAUTH } from "../lib/httplib";
export default {
  name: "Dashboard",
  components: {
    CChartLineSimple,
  },
  data() {
    return {
      outlet: {
        count: 0,
        per_month: [],
        year: 2021,
      },
      user: {
        count: 0,
        per_month: [],
        year: 2021,
      },
      catalog: {
        count: 0,
        per_month: [],
        year: 2021,
      },
      transactions: {
        count: 0,
        per_month: [],
        year: 2021,
      },
      loading: false,
      outletPerCity: [],
    };
  },
  created() {
    const year = new Date().getFullYear();
    this.getOutlet(year);
    this.getUser(year);
    this.getCatalog(year);
    this.getTransaction(year);
    this.getOutletPerCity(year);
  },
  methods: {
    getOutlet(year) {
      this.loading = true;
      HTTPAUTH.get("/api/admin/dashboard/outlet/" + year)
        .then((res) => {
          this.outlet = res.data.data;
          this.loading = false;
        })
        .catch((eres) => {
          this.loading = false;
        });
    },
    getOutletPerCity(year) {
      this.loading = true;
      HTTPAUTH.get("/api/admin/dashboard/per-city/outlet")
        .then((res) => {
          this.outletPerCity = res.data.data;
          this.loading = false;
        })
        .catch((eres) => {
          this.loading = false;
        });
    },
    getUser(year) {
      this.loading = true;
      HTTPAUTH.get("/api/admin/dashboard/user/" + year)
        .then((res) => {
          this.user = res.data.data;
          this.loading = false;
        })
        .catch((eres) => {
          this.loading = false;
        });
    },
    getCatalog(year) {
      this.loading = true;
      HTTPAUTH.get("/api/admin/dashboard/catalog/" + year)
        .then((res) => {
          this.catalog = res.data.data;
          this.loading = false;
        })
        .catch((eres) => {
          this.loading = false;
        });
    },
    getTransaction(year) {
      this.loading = true;
      HTTPAUTH.get("/api/admin/dashboard/transaction/" + year)
        .then((res) => {
          this.transactions = res.data.data;
          this.loading = false;
        })
        .catch((eres) => {
          this.loading = false;
        });
    },
  },
};
</script>
